import axios from "axios";

const API_URL = "https://tourvn.runasp.net/api/Feedback"; // Thay bằng URL API của bạn

export const feedbackService = {
  // ✅ Lấy danh sách feedback của tour
  getByTourId: async (tourId) => {
    return await axios.get(`${API_URL}/tour/${tourId}`);
  },
  getFeedbackCountByTour: async (tourId) => {
    return await axios.get(`${API_URL}/tour/${tourId}/count`);
  },
  // ✅ Tạo feedback mới
  create: async (feedbackData) => {
    return await axios.post(API_URL, feedbackData);
  },

  // ✅ Trả lời một feedback
  reply: async (replyData) => {
    return await axios.post(`${API_URL}`, replyData);
  },

  updateFeedback: async (feedbackData) => {
    return await axios.put(`${API_URL}`, feedbackData);
  },

  deleteFeedback: async (feedbackId) => {
    return await axios.delete(`${API_URL}/${feedbackId}`);
  },

  calculateAverageRating: (feedbacks) => {
    const ratings = feedbacks
      .map((fb) => fb.rating)
      .filter((rating) => rating !== null);
    if (ratings.length === 0) return 0;
    return (
      ratings.reduce((sum, rating) => sum + rating, 0) / ratings.length
    ).toFixed(1);
  },

  calculateRatingStatistics: (feedbacks) => {
    const stats = { 5: 0, 4: 0, 3: 0, 2: 0, 1: 0 };
    feedbacks.forEach((fb) => {
      if (fb.rating) stats[fb.rating]++;
    });

    const total = feedbacks.length;
    return {
      stats,
      percentages: Object.fromEntries(
        Object.entries(stats).map(([rating, count]) => [
          rating,
          total ? ((count / total) * 100).toFixed(1) : 0,
        ])
      ),
    };
  },
};
